module.exports = __webpack_public_path__ + "static/media/tyre-yellow-four1.238099d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-four1.png
// module id = 349
// module chunks = 0